module.exports = __webpack_public_path__ + "img/V22.73dd5664.jpg";